import { QuestionComponentProps } from "..";

import { JobExperienceSelector } from "./components/JobExperienceSelector";

export function JobExperience({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <JobExperienceSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
